import { Link, useNavigate } from 'react-router-dom';
import { PRODUCT_CONFIGURATORS_ROUTE } from '../constants/routePathConstants';
import { getConfigruatorPath } from '../helpers/urlHelper';
import { useConfiguratorActions } from '../hooks/useConfiguratorActions';
import ThumbnailCardUI from './ThumbnailCardUI';
import ThumbnailCardV2 from './ThumbnailCardV2';
import { useDispatch } from 'react-redux';
import { configuratorActions } from '../redux/slicers/configurator/configurator.slicer';
import { apiGetPreviewListing } from '../helpers/api';
import { useState } from 'react';
import Loader from './Loader';
import { getAppState } from '../redux/store';

export const ThumbnailCardConfigurator = ({
  data,
  size,
  fullWidth,
  onSelect,
  selected,
  hideFavourite,
  onDelete,
  customActions,
  onEdit,
  designV2,
  onDuplicatePass,
  isCollectionItem,
  isSharedItem,
  ...rest
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  // const [infoLoading, setInfoLoading] = useState(false)
  // const [infoData, setInfoData] = useState([])

  const {
    onDelete: _onDelete,
    onFavouriteToggle,
    favouriteLoading,
    download,
    downloading,
    onShare,
    addToCollection,
  } = useConfiguratorActions({
    item: data,
    isTemplateCard: rest.isTemplateCard,
  });
  const handleDelete = onDelete || _onDelete;
  const id = data.id;
  let extraprops = { ...rest };
  const url = extraprops.confFilter ? '' : getConfigruatorPath(id);

  onEdit = () => {
    navigate(url);
  };

  const onDuplicate = (val) => {
    onDuplicatePass(val);
  };

  const handleShareClick = async (data) => {
    setLoading(true);
    const lastConf = getAppState().configurator.currentConfigurator;
    if (lastConf?.id !== data?.id) {
      const response = await apiGetPreviewListing(`configurator=${data?.id}`);
      const _data = response?.results || [];
      if (_data?.length) {
        const renderData = _data.find((val) => val?.is_render && val?.is_prototype_allowed);
        if (renderData) dispatch(configuratorActions.setCurrentConfigurator(data));
        else dispatch(configuratorActions.setCurrentConfigurator(null));
      } else dispatch(configuratorActions.setCurrentConfigurator(null));
    }
    onShare();
    setLoading(false);
  };

  // const handleInfoClick = async (data) => {
  //   setInfoLoading(true)
  //   const response = await apiGetPreviewListing(`configurator=${data?.id}`);
  //   const _data = response?.results || [];
  //   if (_data?.length) {
  //     setInfoData(_data)
  //   }
  //   setInfoLoading(false)
  // }

  // product configurator I got thumb key for thumbnail
  const thumbnailImage = data?.thumbnail || data?.thumb;
  return designV2 ? (
    <>
      {loading ? <Loader loading={true} position="fixed" size={30} thickness={3} /> : null}

      <ThumbnailCardV2
        onFavouriteChange={onFavouriteToggle(data)}
        onSelect={onSelect}
        selected={selected}
        isFavourite={data.is_favourite}
        hideFavourite={hideFavourite}
        favouriteLoading={favouriteLoading}
        titleProps={{
          as: Link,
          to: url,
        }}
        // savePreviousRoute={true}
        id={data?.id}
        data={{ ...data, member_details: data?.created_by_details }}
        name={data?.name}
        thumbnail={thumbnailImage}
        images={data?.images}
        date={data.updated_at}
        showMenu
        showCheckbox
        isFavouriteIcon
        onEdit={onEdit}
        onDelete={handleDelete}
        onShare={() => handleShareClick(data)}
        customActions={customActions}
        // onDownload={() => download(data?.id)}
        downloadLoading={downloading}
        fullWidth={fullWidth}
        onAddToCollection={addToCollection}
        redirect={true}
        redirectTarget="_self"
        redirectURL={`${PRODUCT_CONFIGURATORS_ROUTE}/${data?.id}`}
        onDuplicate={!isCollectionItem && !isSharedItem ? onDuplicate : null}
        userCard={true}
        // onInfoClick={handleInfoClick}
        // infoData={infoData}
        // infoLoading={infoLoading}
        {...rest}
      />
    </>
  ) : (
    <ThumbnailCardUI
      key={id}
      id={id}
      onEdit={onEdit}
      to={rest.isTemplateCard ? '' : url}
      thumbnail={thumbnailImage}
      images={data?.images}
      name={data.name}
      isFavourite={data.is_favourite}
      favouriteLoading={favouriteLoading}
      date={data.updated_at}
      onDelete={handleDelete}
      onShare={() => handleShareClick(data)}
      onFavouriteChange={onFavouriteToggle(data)}
      customActions={customActions}
      size={size}
      titleProps={{
        as: Link,
        to: url,
      }}
      // onDownload={() => download(data?.id)}
      downloadLoading={downloading}
      fullWidth={fullWidth}
      onSelect={onSelect}
      selected={selected}
      onAddToCollection={addToCollection}
      hideFavourite={hideFavourite}
      data={data}
      {...rest}
    />
  );
};
